import { createSlice } from "@reduxjs/toolkit";
import { archiveActivity, getActivityList } from "./_activityAction";


interface ActivityState {
  activityList: any[];
  loading: boolean;
  error: string | null;
  totalCount: number;
}

const initialState: ActivityState = {
  activityList: [],
  loading: false,
  error: null,
  totalCount: 0,
};


export const activityReducer = createSlice({
  name: "activity",
  initialState: initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Log Hour List
      .addCase(getActivityList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getActivityList.fulfilled, (state, action) => {
        state.loading = false;
        state.activityList = action.payload?.data;
        state.totalCount = action.payload?.count;
      })
      .addCase(getActivityList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      // Archive Activity
      .addCase(archiveActivity.fulfilled, (state, action) => {        
        state.activityList = state.activityList.filter((activity) => activity?.uuid !== action.payload?.data?.uuid);
      })
      .addCase(archiveActivity.rejected, (state, action) => {
        state.error = action.payload as string;
      })
  },

});


export const { clearError } = activityReducer.actions;
export default activityReducer;